export const ERROR_EMAIL_FORMAT = 'Bitte gib eine gültige E-Mail-Adresse ein.';
export const ERROR_USER_SELECTION_REQUIRED = 'Bitte wähle einen Benutzer aus.';
export const ERROR_PASSWORD_FORMAT = 'Bitte gib dein Passwort ein.';
export const ERROR_RESET_SEND_MAIL = 'Der Passwort-Link konnte nicht versendet werden.';
export const ERROR_LOGIN_FAILED =
  'Die Anmeldung ist fehlgeschlagen. Bitte überprüfe E-Mail Adresse und Passwort.';

export const LABELS_LOGIN_MODE = {
  title: 'Herzlich Willkommen',
  subtitle: 'Hier einloggen:',
  switchModeLabel: 'Passwort vergessen?',
  submitLabel: 'Log in',
};

export const LABELS_RESET_MODE = {
  title: 'Passwort zurücksetzen',
  subtitle: 'Für welchen Account soll das Passwort zurückgesetzt werden?',
  switchModeLabel: 'Zurück zum Login',
  submitLabel: 'Zurücksetzen',
};

export const LABELS_RESET_CONFIRM_MODE = (resetMail: string) => ({
  title: 'Passwort zurückgesetzt',
  subtitle: `Wir haben dir einen Link an <b>${resetMail}</b> geschickt. Folge dem Link um ein neues Passwort zu setzen.`,
  switchModeLabel: 'E-Mail erneut senden',
  submitLabel: 'Zurück zum Login',
});
